// =====================================================================================================================
// GLOBAL APP VALUES
//

export class Globals {

    // =================================================================================================================
    // UI THEME
    //
    public static uiTheme = {

        // Seen by the platform:
        FONT_Default:                   "Lato, sans-serif",
        COLOR_Select:                   "transparent",


        // -------------------------------------------------------------------------------------------------------------
        // COLORS

        // Solid fill colors
        COLOR_BaseSolidDarkFill:        "#000000",
        COLOR_BaseSolidLightFill:       "#FFFFFF",

        // Clear (transparent) fill colors
        COLOR_ResumeWindow:             '#4c2f0a8e',
        COLOR_ProjectsWindow:           '#150021c2',

        // Font
        COLOR_FontNeutral:              "rgba(222, 255, 245, 0.9)",
        COLOR_FontEmphasize:            "rgba(60, 255, 244, 0.85)",
        COLOR_FontUnemphasize:          "#888888FF",
        COLOR_FontDisabled:             "#B7B7B7FF",

        // Visual Grouping/Separation
        COLOR_GroupingLine:             "#EEEEEEFF",
        COLOR_GroupingBackground:       "#F7F7F7FF",

        // Shadow
        COLOR_Shadow:                   "#22222266",
        COLOR_FontShadow:               "1px 1px 2px black",


        // Logo Colors
        COLOR_LogoPurple:               "#b580d1ff",
        COLOR_LogoOrange:               "#e99d5dff",
        COLOR_LogoGreen:                "#89e4bcff",

        // Action colors
        COLOR_ActionButton:             "#480063ff",
        COLOR_ProjectButton:            "#1d8255ff", //"#2c592cff",


        // -------------------------------------------------------------------------------------------------------------
        // SIZES

        // Font
        SIZE_FontWasteful:              "48pt",
        SIZE_FontEmphasize:             "18pt",
        SIZE_FontNeutral:               "14pt",
        SIZE_FontUnemphasize:           "10pt",

        // Spacing
        SPACING_Wasteful:               "48px",
        SPACING_Emphasize:              "24px",
        SPACING_Neutral:                "12px",
        SPACING_Nest:                   "6px",

        SPACING_LineHeightNeutral:      "1.6",


        // -------------------------------------------------------------------------------------------------------------
        // BORDERS / FRAMES

        // Borders
        BORDER_Rounded:                 "12px"

    };
}
